(function(){

    'use strict';

    angular
        .module("iqxCore")
        .filter("time", timeFilter)

    function timeFilter($filter){
        return function (time, format) {
            var parts = time.split(':');

            var date = new Date(0, 0, 0, parts[0], parts[1], (parts[2]||0));
            return $filter('date')(date, format || 'h:mm');
        };
    }

})()